/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import {
  Checkbox, Col, Divider, Flex, message, Row
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import {
  Button, Image, Radio, Typography
} from 'tfc-components';

import {
  PackageOption
} from '.';

import backupCardImg from 'assets/images/backup_card.jpg';
import imgCard from 'assets/images/card_notice.png';
import masterCard from 'assets/images/master_card.png';
import nganLuongImg from 'assets/images/nganluong-logo-color.png';
import mainCardImg from 'assets/images/primary_card.jpg';
import visa from 'assets/images/visa.png';
import Modal from 'components/organisms/Modal';
import { getCardService, renewAddOnService, renewSubcriptionService } from 'services/overview';
import { CardData, InvoiceData } from 'services/overview/types';
import { ROUTE_PATHS } from 'utils/constants';
import mapModifiers from 'utils/functions';

interface Props {
  total: number;
  billingType: 'one-time' | 'subscription';
  // handleCheckout: () => void;
  mainPackages: PackageOption | undefined;
  invoiceData: InvoiceData,
  billingData: any;
  isAddOn: boolean
}

const paymentMethodsSubscription = [
  'JCB',
  'Master Card',
  'Visa'
];

const paymentMethodsOnetime = [
  'Viet QR',
  'ATM Card',
  'Internet Banking',
  'E-Wallet',
  'JCB',
  'Master Card',
  'Visa'
];

const RETURN_URL: string = `${window.location.origin}${ROUTE_PATHS.OVER_VIEW}`;
const CANCEL_URL: string = `${window.location.origin}${ROUTE_PATHS.OVER_VIEW}`;
// const RETURN_URL: string = `https://evol-studio.evollabs.vn${ROUTE_PATHS.OVER_VIEW}`;
// const CANCEL_URL: string = `https://evol-studio.evollabs.vn${ROUTE_PATHS.OVER_VIEW}`;

const Confirmation: React.FC<Props> = ({
  total, billingType,
  mainPackages, invoiceData,
  billingData,
  isAddOn
}) => {
  /* Hooks */
  const navigate = useNavigate();

  /* /state */
  const [checked, setChecked] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [usedCard, setUsedCard] = useState<'main' | 'backup'>('main');
  const [paymentMethod, setMethod] = useState<'card' | 'other'>('card');
  const [mainCard, setMainCard] = useState<CardData | null>(null);
  const [backupCard, setBackupCard] = useState<CardData | null>(null);

  /* Queries */
  const { data: cardData, } = useQuery({
    queryKey: ['get-card'],
    queryFn: getCardService,
  });

  /* Effect */
  useEffect(() => {
    const _mainCard = cardData?.find(
      (card) => card?.cardInfoData?.cardIndex === 1
    );
    const _backupCard = cardData?.find(
      (card) => card?.cardInfoData?.cardIndex === 2
    );

    if (_mainCard) {
      setMainCard(_mainCard);
      setBackupCard(_backupCard ?? null);
    } else if (_backupCard) {
      setMainCard(_backupCard);
      setBackupCard(null);
    } else {
      setBackupCard(null);
      setMainCard(null);
    }
    if (cardData?.length === 0) {
      setMethod('other');
    }
  }, [cardData, cardData?.length]);

  const { mutate: renewMutate } = useMutation(
    ['renew-package'],
    renewSubcriptionService,
    {
      onSuccess(data) {
        if (data && data?.link) {
          window.location.href = (data.link);
        } else {
          message.success('Renew plan successfully');
          navigate(ROUTE_PATHS.OVER_VIEW);
        }
      },
      onError() {
        message.error('Something went wrong, please try again later');
      },
    }
  );

  const { mutate: renewAddOnMutate } = useMutation(
    ['renew-addOn-package'],
    renewAddOnService,
    {
      onSuccess(dataSuccess) {
        if (dataSuccess && dataSuccess?.link) {
          window.location.href = (dataSuccess.link);
        } else {
          message.success('Renew plan successfully');
        }
      },
      onError() {
        message.error('Something went wrong, please try again later');
      },
    }
  );

  const handleCheckout = async () => {
    if (isAddOn) {
      renewAddOnMutate({
        code: billingData.planData?.code,
        returnUrl: RETURN_URL,
        cancelUrl: CANCEL_URL,
        cardTokenId: (() => {
          if (paymentMethod !== 'card') return null;
          if (usedCard === 'main') return mainCard?.cardInfoData?.id || 0;
          return backupCard?.cardInfoData?.id || 0;
        })(),
      });
      return;
    }
    renewMutate({
      code: billingData.planData?.code,
      returnUrl: RETURN_URL,
      cancelUrl: CANCEL_URL,
      cardTokenId: (() => {
        if (paymentMethod !== 'card') return null;
        if (usedCard === 'main') return mainCard?.cardInfoData?.id || 0;
        return backupCard?.cardInfoData?.id || 0;
      })(),
    });
  };

  return (
    <div className="p-checkout_confirmation">
      <div className="p-checkout_confirmation_wrap">
        <div className="p-checkout_productWrap">
          <Typography.Text fontweight="600" extendClasses="p-checkout_titleProduct fs-20x24">
            Product list
          </Typography.Text>

          <div className="p-checkout_table">
            <div className="p-checkout_table_head">
              <div>Package</div>
              <div>Unit</div>
              <div>Duration</div>
              <div>Base price (VND)</div>
              <div>Total price (VND)</div>
            </div>

            <div className="p-checkout_table_row">
              <div>{mainPackages?.name}</div>

              <div className="p-checkout_table_quantity">

                <Typography.Text extendClasses="p-checkout_table_inputText">
                  {1}
                </Typography.Text>
              </div>

              <div className="p-checkout_table_quantity">

                <Typography.Text extendClasses="p-checkout_table_inputText">
                  {mainPackages?.duration === 3 ? 'Year' : 'Month'}
                </Typography.Text>
              </div>

              <div>{mainPackages?.amount.toLocaleString('vi')}</div>

              <div className="p-checkout_table_totalValue">
                {mainPackages?.amount.toLocaleString('vi')}
              </div>
            </div>

            <div className="p-checkout_table_row p-checkout_table_total">
              <Typography.Text fontweight="600" extendClasses="p-checkout_table_totalLabel">
                Total
              </Typography.Text>
              <div />
              <div />
              <div />
              <Typography.Text
                fontweight="600"
                extendClasses="p-checkout_table_totalValue"
              >
                {mainPackages?.amount.toLocaleString('vi')}
              </Typography.Text>
            </div>
          </div>
        </div>

        {/* <div className="p-paymentMethod_packageDetail">
          <Typography.Text fontweight="600" extendClasses="fs-20x24">Plan Overview</Typography.Text>

          <div className="p-paymentMethod_packageDetail_description">
            <Typography.Text>
              By renewing this package, you will continue
              to use the same resources without interruption, starting from
              {' '}
              {dayjs().format('DD/MM/YYYY')}
            </Typography.Text>

            {mainPackages?.numberOfAgent && mainPackages?.numberOfAgent > 0 && (
              <Typography.Text>
                Number of chatbots:
                {' '}
                {mainPackages?.numberOfAgent}
                {' '}
                chatbots
              </Typography.Text>
            )}

            {mainPackages?.numberOfSession && mainPackages?.numberOfSession > 0 ? (
              <Typography.Text>
                Number of sessions:
                {' '}
                {mainPackages?.numberOfSession}
                {' '}
                chatbot sessions
              </Typography.Text>
            ) : null}

            {mainPackages?.numberOfFile && mainPackages?.numberOfFile > 0 ? (
              <Typography.Text>
                {`Knowledge base capacity: ${mainPackages?.numberOfFile}
                files${mainPackages?.numberOfWebsite && mainPackages?.numberOfWebsite
                 > 0 && `, ${mainPackages?.numberOfWebsite}`}
                  websites${mainPackages?.totalSizeLimit && mainPackages?.totalSizeLimit > 0 && `,
                   ${mainPackages?.totalSizeLimit} MB storage`},
                    and permission to access to all features included in the plan`}
              </Typography.Text>
            ) : null}
          </div>

        </div> */}

        <div className="p-checkout_spacingBottom p-addNewPackage_mt32">
          <Typography.Text fontweight="600" extendClasses="p-checkout_titleProduct p-checkout_billingInfo_spacing fs-20x24">
            Invoice Information
          </Typography.Text>
          <div className="p-checkout_buyerInfo">
            <Row>
              <Col className="p-checkout_buyerInfo_col">
                <Typography.Text fontweight="600" extendClasses="p-checkout_billingType_formLabel p-home_demo_formLabel fs-14x18">Invoice Recipient Type</Typography.Text>
                <Typography.Text extendClasses="p-checkout_text">
                  {invoiceData?.invoiceType === 2 ? 'Business' : 'individual'}
                </Typography.Text>
              </Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col className="p-checkout_buyerInfo_col">
                <Typography.Text fontweight="600" extendClasses="p-checkout_billingType_formLabel p-home_demo_formLabel fs-14x18">
                  {invoiceData?.invoiceType === 2
                    ? 'Tax ID' : 'National ID'}
                </Typography.Text>
                <Typography.Text extendClasses="p-checkout_text">
                  {invoiceData?.invoiceType === 2 ? invoiceData?.taxCode
                    : invoiceData?.taxCode}
                </Typography.Text>
              </Col>
              <Col style={{ flex: 1 }} className="p-checkout_buyerInfo_col">
                <Typography.Text fontweight="600" extendClasses="p-checkout_billingType_formLabel p-home_demo_formLabel fs-14x18">
                  {invoiceData?.invoiceType === 2
                    ? 'Company name' : 'Full name'}
                </Typography.Text>
                <Typography.Text extendClasses="p-checkout_text">
                  {invoiceData?.invoiceType === 2 ? invoiceData?.companyName
                    : invoiceData?.companyName}
                </Typography.Text>
              </Col>
            </Row>
            <Col className="p-checkout_buyerInfo_col" style={{ width: '100%' }}>
              <Typography.Text fontweight="600" extendClasses="p-checkout_billingType_formLabel p-home_demo_formLabel fs-14x18">Full Address</Typography.Text>
              <Typography.Text extendClasses="p-checkout_text">{invoiceData?.fullAddress}</Typography.Text>
            </Col>
            <Row>
              <Col>
                <Typography.Text fontweight="600" extendClasses="p-checkout_billingType_formLabel p-home_demo_formLabel fs-14x18">Invoice Email</Typography.Text>
                <div className="p-checkout_textTagWrap">
                  {invoiceData?.invoiceEmails?.map((item) => (
                    <Typography.Text extendClasses="p-checkout_textTag">{item}</Typography.Text>
                  ))}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <div className="p-addNewPackage_confirmation_payment p-addNewPackage_productWrap">
        <div>
          <div className="p-addNewPackage_padding24">
            <Typography.Text fontweight="600" extendClasses=" p-home_demo_formLabel fs-20x24">{cardData && cardData.length > 0 ? 'Payment method' : 'Support payment method'}</Typography.Text>
          </div>

          <div className="p-addNewPackage_confirmation_paymentMethods p-addNewPackage_padding24">
            {
              mainCard
              && (
                <div>
                  <Flex gap={4} align="center">
                    <Radio checked={paymentMethod === 'card'} onClick={() => setMethod('card')} size={20} />
                    <Typography.Text fontweight="600" extendClasses="fs-14x20">Your card</Typography.Text>
                  </Flex>
                  {
                    paymentMethod === 'card'
                    && (
                      <>
                        <div className="t-payment_card_imgCardWrap">
                          <Image
                            imgSrc={usedCard === 'main' ? mainCardImg : backupCardImg}
                            alt="primary-card"
                            ratio={310 / 171}
                            extendClasses="p-paymentMethod_cardInfo_cardImg"
                          />
                          {usedCard === 'main'

                            ? (
                              <div className="t-overview_cardInfo  t-overview_cardInfo-padding16">
                                <Image
                                  imgSrc={
                                    mainCard?.cardInfoData?.paymentMethod === 'MASTERCARD'
                                      ? masterCard
                                      : visa
                                  }
                                  ratio={50 / 32}
                                  alt="card-brand"
                                  extendClasses="t-overview_cardInfo_cardBrannd"
                                />
                                <Typography.Text
                                  extendClasses="fs-28x33 t-overview_cardInfo_cardNumber"
                                  fontweight="600"
                                >
                                  {mainCard?.cardInfoData?.cardNumber}
                                </Typography.Text>

                                <Flex justify="space-between">
                                  <Flex vertical>
                                    <Typography.Text>Card holder</Typography.Text>
                                    <Typography.Text
                                      extendClasses="fs-16x24 t-overview_cardInfo_cardNumber"
                                      fontweight="600"
                                    >
                                      {mainCard?.cardInfoData?.cardHolderName}
                                    </Typography.Text>
                                  </Flex>
                                  <Flex vertical align="flex-end">
                                    <Typography.Text>Expires </Typography.Text>
                                    <Typography.Text
                                      extendClasses="fs-16x24 t-overview_cardInfo_cardNumber"
                                      fontweight="600"
                                    >
                                      {`${mainCard?.cardInfoData?.cardExpireMonth}/${mainCard?.cardInfoData?.cardExpireYear}`}
                                    </Typography.Text>
                                  </Flex>
                                </Flex>
                              </div>
                            )
                            : (
                              <div className="t-overview_cardInfo  t-overview_cardInfo-padding16">
                                <Image
                                  imgSrc={
                                    backupCard?.cardInfoData?.paymentMethod === 'MASTERCARD'
                                      ? masterCard
                                      : visa
                                  }
                                  ratio={50 / 32}
                                  alt="card-brand"
                                  extendClasses="t-overview_cardInfo_cardBrannd"
                                />
                                <Typography.Text
                                  extendClasses="fs-28x33 t-overview_cardInfo_cardNumber"
                                  fontweight="600"
                                >
                                  {backupCard?.cardInfoData?.cardNumber}
                                </Typography.Text>

                                <Flex justify="space-between">
                                  <Flex vertical>
                                    <Typography.Text>Card holder</Typography.Text>
                                    <Typography.Text
                                      extendClasses="fs-16x24 t-overview_cardInfo_cardNumber"
                                      fontweight="600"
                                    >
                                      {backupCard?.cardInfoData?.cardHolderName}
                                    </Typography.Text>
                                  </Flex>
                                  <Flex vertical align="flex-end">
                                    <Typography.Text>Expires </Typography.Text>
                                    <Typography.Text
                                      extendClasses="fs-16x24 t-overview_cardInfo_cardNumber"
                                      fontweight="600"
                                    >
                                      {`${backupCard?.cardInfoData?.cardExpireMonth}/${backupCard?.cardInfoData?.cardExpireYear}`}
                                    </Typography.Text>
                                  </Flex>
                                </Flex>
                              </div>
                            )}

                        </div>

                        {backupCard && (
                          <Button
                            onClick={() => {
                              if (usedCard === 'main') {
                                setUsedCard('backup');
                              } else {
                                setUsedCard('main');
                              }
                            }}
                            extendClasses="p-addNewPackage_cardInfo_btnTxt"
                            variant="text"
                          >
                            {usedCard === 'main' ? 'Use backup card' : 'Use primary card'}
                          </Button>
                        )}

                      </>
                    )
                  }
                </div>
              )
            }

            <div className={`p-paymentMethod_cardInfo_others ${cardData && cardData.length === 0 ? 'p-addNewPackage_mt0' : ''}`}>
              {
                cardData && cardData?.length > 0
                && (
                  <Flex gap={4} align="center">
                    <Radio checked={paymentMethod === 'other'} onClick={() => setMethod('other')} size={20} />
                    <Typography.Text fontweight="600" extendClasses="fs-14x20">Others</Typography.Text>
                  </Flex>
                )
              }

              {
                paymentMethod === 'other' && (
                  <ul className="p-addNewPackage_confirmation_listPayment">
                    {(billingType === 'one-time' ? paymentMethodsOnetime : paymentMethodsSubscription)
                      .map((item) => (
                        <li
                          className="p-addNewPackage_confirmation_radio"
                          key={item}
                        >
                          <Typography.Text extendClasses="p-addNewPackage_text fs-14x18">{item}</Typography.Text>
                        </li>
                      ))}
                  </ul>
                )
              }

            </div>
          </div>

          <div className="p-addNewPackage_padding24">
            <div>
              <Row justify="space-between">
                <Typography.Text extendClasses="fs-16x18">Total</Typography.Text>
                <Typography.Text fontweight="600" extendClasses="p-addNewPackage_packageCard_amount fs-18x21">
                  {total.toLocaleString('vi')}
                  {' '}
                  VNĐ
                </Typography.Text>
              </Row>
              <div className="p-addNewPackage_confirmation_agreement">
                <Checkbox onChange={() => setChecked(!checked)} />
                <Typography.Text extendClasses="p-addNewPackage_confirmation_agreementText fs-14x18">
                  I agree to Ask2Auto
                  {' '}
                  <span className="p-addNewPackage_confirmation_link" onClick={() => window.open('/privacy-policy', '_blank')}>privacy policy</span>
                  {' '}
                  and
                  {' '}
                  <span className="p-addNewPackage_confirmation_link" onClick={() => window.open('/terms-and-conditions', '_blank')}>terms</span>
                </Typography.Text>
              </div>
              <Button
                onClick={() => (billingType === 'one-time' || paymentMethod === 'card' ? handleCheckout() : setOpenModal(true))}
                disabled={!checked}
                extendClasses={mapModifiers('fButton fButton-primary p-addNewPackage_confirmation_button', !checked ? 'disabled' : 'active')}
              >
                {paymentMethod === 'card' ? 'Pay' : 'Select Payment Method'}
              </Button>
            </div>
            <div className="p-addNewPackage_confirmation_support">
              <Typography.Text extendClasses="p-addNewPackage_confirmation_supportText">Supported by payment gateway</Typography.Text>
              <div className="p-addNewPackage_confirmation_supportImg">
                <Image extendClasses="p-addNewPackage_confirmation_extend" imgSrc={nganLuongImg} alt="nganLuongImg" ratio={394 / 87} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={openModal}
        className="p-checkout_modal"
        width={800}
        title="Notice"
        closeIcon
        cancelButton={{
          handleClick: () => {
            setOpenModal(false);
          },
        }}
        okButton={{
          handleClick: () => {
            setOpenModal(false);
          },
        }}
      >
        <div className="p-checkout_modal_content">
          <Divider style={{ margin: '8px 0 16px 0' }} />
          <Image extendClasses="p-checkout_modal_image" imgSrc={imgCard} alt="demoImg" ratio={1447 / 680} />
          <Typography.Text extendClasses="p-checkout_modal_description f-14x18">
            To enable automatic billing, you must agree to save
            your card information with our payment partner
          </Typography.Text>
          <Divider style={{ margin: '12px 0' }} />
          <div className="p-checkout_modal_buttonWrap">
            <Button onClick={() => { handleCheckout(); }} variant="primary" extendClasses="p-checkout_modal_button">I understand</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Confirmation;
